module.exports = __webpack_public_path__ + "img/Topup.f162cc7a.svg";